import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';

export function Layout() {
  return (
    <div className="p-sm gap-2xs flex h-screen">
      <Sidebar />
      <main className="bg-base-white custom-scrollbar flex-1 overflow-auto rounded-3xl">
        <div className="p-xl min-h-full">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
